import { useMemo, useState } from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { snackbarHelperActions } from 'src/components/20-helper-views/snackbar/useSnackbar';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import useSearch from 'src/hooks/useSearch';
import { useNotesListQuery } from 'src/modules/exam-preparation/graphql/notes/getList';
import { useAddNoteToSubjectMutation } from 'src/modules/exam-preparation/graphql/subject/addNoteToSubject';
import useI18n from 'src/modules/translations/hooks/useI18n';
export default function useData(subjectID) {
    const [searchState, searchActions] = useSearch('debounce', 500, '');
    const [selectedNoteID, setSelectedNoteID] = useState();
    const [listQueryState, listQueryActions] = useNotesListQuery();
    const [addMutationState, addMutationActions] = useAddNoteToSubjectMutation();
    const listQueryVariables = useMemo(() => ({
        ...(searchState.deferredVal.trim().length > 0 && {
            filters: {
                title: searchState.deferredVal.trim(),
            },
        }),
    }), [searchState.deferredVal]);
    const { translate } = useI18n();
    const attachNote = useStableCallback(() => {
        if (!selectedNoteID || addMutationState.loading) {
            return;
        }
        actions.addMutation.submit({
            variables: {
                subjectID,
                noteID: selectedNoteID,
            },
            onCompleted() {
                bottomDrawerHelperActions.hide();
                snackbarHelperActions.show({
                    variant: 'POSITIVE',
                    duration: 'SHORT',
                    message: translate('Note added successfully'),
                });
            },
        });
    });
    const state = {
        search: searchState,
        selectedNoteID,
        listQuery: listQueryState,
        listQueryVariables,
        addMutation: addMutationState,
    };
    const actions = {
        search: searchActions,
        setSelectedNoteID,
        listQuery: listQueryActions,
        addMutation: addMutationActions,
        attachNote,
    };
    return [state, actions];
}
